var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pkb-wrapper f-col fill-height align-h-center" },
    [
      _c("pkb-header"),
      _c("div", { staticClass: "pkb-body" }, [
        _c("h2", { staticClass: "page-title" }, [_vm._v("Related Programs")]),
        _c("div", {
          staticClass: "page-info",
          domProps: { innerHTML: _vm._s(_vm.$parent.about) },
        }),
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.$parent.programs, function (program) {
            return _c("div", { staticClass: "program col-md-6" }, [
              _c("img", { attrs: { src: program.bgImage } }),
              !program.comingSoon
                ? _c("h4", [
                    _c("a", { attrs: { href: program.linkUrl } }, [
                      _vm._v(_vm._s(program.title)),
                    ]),
                  ])
                : _c("h4", [
                    _vm._v(_vm._s(program.title) + " "),
                    _c("span", { staticClass: "coming-soon" }, [
                      _vm._v("(Coming Soon)"),
                    ]),
                  ]),
              _c("p", [_vm._v(_vm._s(program.body))]),
            ])
          }),
          0
        ),
      ]),
      _c("pkb-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }